<template>
    <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        :retain-focus="false"
        persistent
        transition="dialog-bottom-transition">
        <template v-slot:activator="{ on, attrs }">
            <v-btn 
                v-bind="attrs"
                v-on="on" 
                x-medium
                large block 
                rounded 
                color="primary"
                dark>
                Agregar subcategoría
            </v-btn>
        </template>
        <v-card>
            <v-toolbar
              dark
              color="secondary">
                <v-btn
                    icon
                    dark
                    class="btn btn-primary"
                    @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Agregar Subcategoría</v-toolbar-title>

                <template v-slot:extension>
                  <v-tabs v-model="tab" align-with-title>
                    <v-tabs-slider color="accent"></v-tabs-slider>

                    <v-tab v-for="item in items" :key="item">
                      {{ item }}
                    </v-tab>
                  </v-tabs>
                </template> 

            </v-toolbar>

            <v-tabs-items v-model="tab" class="container mt-5">
              
              <v-tab-item>
                <div class="container mt-4">
                  <addSubcategoriesMarketplace
                  :category="category"
                  />
                </div>
              </v-tab-item>

          </v-tabs-items>
  
        </v-card>
    </v-dialog>
  
</template>
  
<script>

  import  EventBus  from '@/utils/event_bus.js';
  import addSubcategoriesMarketplace from '@/views/categories_marketplace/pages/add_subcategories_marketplace/components/form_subcategories_marketplace_component.vue';
  
  export default {
    
    name:"addCategoriesPage",
    components: {
      addSubcategoriesMarketplace
    },
    props: {
      category: {
        required: true
      },
    },
    data () {
      return {
        dialog: false,
        tab: null,
        items: [
          "Datos Completos",
        ],
   
      }
      
    },

    mounted() {
      // Escucha el evento emitido por el componente hijo
      EventBus.$on('formSubMarketplace-submitted-successfully', () => {
          // Cierra el v-dialog
          this.dialog = false;
          EventBus.$emit('reload-subcategories-marketplace');
      });
    },

    methods: {
    
    },
  
    computed: { 
   
    }
  };
</script>
  